/* eslint react-hooks/exhaustive-deps: 0 */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';

import helpers from 'utils/helpers';
import { getTermsUrl, getPrivacyUrl, openPopupWindow } from 'utils/links';
import ImageLogo from 'assets/images/logo.svg';
import ImageMenu from 'assets/images/menu.svg';
import Sidebar from 'components/common/Sidebar';
import { StyledNav } from 'components/Styled';

import NoticeBar from 'components/common/NoticeBar';

class Navigation extends Component {
  state = {
    sidebarVisible: false,
    offsetTop: 0,
    isMobile: helpers.isMobile('any')
  };

  handleSidebarClose = () => {
    this.setState({
      sidebarVisible: false
    });
  };

  handleSidebarOpen = () => {
    this.setState({
      sidebarVisible: true
    });
  };

  handleLanguageChnage = lang => {
    this.props.i18n.changeLanguage(lang);
    const pathname = this.props.location.pathname.replace(
      `/${localStorage.i18nextLng}`,
      `/${lang}`
    );
    this.props.history.push(`${process.env.PUBLIC_URL}${pathname}`);
    this.props.i18n.changeLanguage(lang);
  };

  componentDidMount() {
    window.onresize = () => {
      const isMobile = helpers.isMobile('any');
      this.setState({ isMobile });
    };

    window.onscroll = () => {
      const offsetTop = window.pageYOffset;
      this.setState({ offsetTop });
    };
  }

  handleTermsClick = e => {
    e.preventDefault();
    const lang = helpers.getCurrentLang();
    const country = helpers.getCurrentCountry(true);
    const url = getTermsUrl(lang, country);
    openPopupWindow(url);
  };

  handlePrivacyClick = e => {
    e.preventDefault();
    const lang = helpers.getCurrentLang();
    const country = helpers.getCurrentCountry(true);
    const url = getPrivacyUrl(lang, country);
    openPopupWindow(url);
  };

  render() {
    return (
      <StyledNav>
        <NoticeBar body="" />
        <div
          id="app-header"
          style={{
            width: '100%',
            maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`,
            margin: '0 auto',
            position: 'relative',
            zIndex: 1,
            padding: '15px 20px',
            backgroundColor: '#57D7DD',
            flex: '0 0 auto'
          }}
          className={[this.props.adminLogin ? 'adminNav' : '']}>
          <a href="/">
            <img src={ImageLogo} style={{ width: '143px' }} alt="" />
          </a>
          {this.props.adminLogin ? (
            <span
              style={{
                width: '100%',
                maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`,
                margin: '0 auto',
                position: 'relative',
                zIndex: 1,
                padding: '15px',
                color: '#fff',
                textAlign: 'bottom',
                fontSize: '12px',
                fontWeight: '700'
              }}>
              {this.props.t('sidebar.login_as')}
            </span>
          ) : (
            ''
          )}
          <Button
            style={{
              float: 'right',
              width: '40px',
              height: '36px',
              border: 0,
              background: 'none',
              padding: 0,
              boxShadow: 'none'
            }}
            onClick={this.handleSidebarOpen}>
            <img src={ImageMenu} style={{ width: '20.9px' }} alt="" />
          </Button>
          <Sidebar
            visible={this.state.sidebarVisible}
            onClose={this.handleSidebarClose}
          />
        </div>
        <div
          style={{
            flex: '1 0 auto',
            display: 'flex',
            flexDirection: 'column'
          }}>
          {this.props.children}
        </div>
      </StyledNav>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.user || false,
    adminLogin: state.auth.adminLogin || false,
    userType: state.auth.userType || 'personal'
  };
};

export default withTranslation()(
  connect(mapStateToProps, {})(withRouter(Navigation))
);
